import { TeamMessage } from "@app/shared/classes/team-message";
import { TeamMessageReceiverType } from "@app/shared/enums";

export class TeamMessageHelper {
  static GetReveiverType(tMessage: TeamMessage) {
    if (tMessage.countries && tMessage.countries.length > 0) {
      return TeamMessageReceiverType.COUNTRY;
    }

    if (tMessage.subRegion_Ids && tMessage.subRegion_Ids.length > 0) {
      return TeamMessageReceiverType.SUB_REGION;
    }

    if (tMessage.terminal_Ids && tMessage.terminal_Ids.length > 0) {
      return TeamMessageReceiverType.TERMINAL;
    }

    if (tMessage.driver_Ids && tMessage.driver_Ids.length > 0) {
      return TeamMessageReceiverType.DRIVER;
    }

    return TeamMessageReceiverType.UNKNOW;
  }
}
